import React from "react";
import BlogFifteen from "../component/BlogFifteen";

function BlogFifteenContainer() {
  return <BlogFifteen />;
}
export default BlogFifteenContainer;
